export const messages = {
  en: {
    greeting: "Hello!",
    home: "home",
    zhichi: "support",
    more: "Get the latest InHand device documentation, firmware, and development tools to stay up-to-date",
    download: "Download",
    Firmware: "Firmware",
    ziyuan: "Resource Center",
    name: "NAME",
    type: "TYPE",
    date: "DATE",
    file: "FILE",
    FileName: "File Name",
    Version: "Version",
    Size: "Size",
    Products: "Products",
    Descriptions: "Descriptions",
    ReleaseNotes: "Release Notes",
    Checksum: "Checksum",
    handbook: "Brochures",
    aiPlaceholder: "Ask InHand AI Assistant",
    searchPlaceholder: "Search docs, firmware...",
    aiTitle: "Hi, I am InHand AI Assistant!",
    aiDesc:
      "Powered by advanced AI, integrated with InHand product docs, manuals, and solutions. Feel free to ask about industrial IoT, product selection, technical support, and more!",
    other: "Other",
    fileCount: "{count} files",
  },
  cn: {
    greeting: "你好!",
    home: "首页",
    zhichi: "支持",
    ziyuan: "资源中心",
    more: "获取最新的InHand设备文档、固件和开发工具，随时掌握最新信息。",
    download: "下载",
    Firmware: "固件",
    name: "名称",
    type: "文件类型",
    date: "发布日期",
    file: "文件",
    FileName: "文件名",
    Version: "版本号",
    Size: "文件大小",
    Products: "产品",
    Descriptions: "描述",
    ReleaseNotes: "发布说明",
    Checksum: "校验和",
    handbook: "产品宣传册",
    aiPlaceholder: "询问InHand智能助手",
    searchPlaceholder: "检索资源中心文档，固件",
    aiTitle: "Hi，我是 InHand 智能助手！",
    aiDesc:
      "基于 AI 大模型，融合了映翰通全线产品文档、手册资料和解决方案。欢迎您询问工业物联网、产品选型、技术支持等相关问题",
    other: "其他",
    fileCount: "{count} 个文件",
  },
};
